<template>
  <sidebar-item class="search_db open" :class="{ 'extended': extended }">
    <h2 v-translate>Zdroj: Externí DB</h2>
    <div class="item-external-sources-button-refresh" v-if="currentItem && currentItem.link" />
    <app-input
      class="field_search"
      inputClass="search clearable"
      ref="autocompleteSearch"
      :placeholder="translations.searchByName"
      :autocomplete="true"
      :autocompleteSource="autocompleteSource"
      :autocompleteMultilevelOptions="true"
      :autocompleteFilterResults="false"
      :autocompleteToplevelHeaders ="externalDbAutocompleteHeaders"
      :value="value"
      :find-autocomplete-on-create="true"
      :data-pending="pending"
      @autocompleteValueChanged="onItemClicked"
      @input="onInputChanged"
      @focus="onFocus"
      @blur="onBlur"
    />
      <app-tabs
          v-if="itemId"
          :colsTabs="[0,1]"
          :shouldLoadFirstTab="true"
          :sidebar-tabs="true"
      >
        <div :title="translations.texts">
          <form class="item-external-sources-checkboxes">
            <p class="field field_all">
                <input class="btn btn_next btn_grey" type="submit" :value="$gettext('Přepsat vše')" @click.prevent="moveExternalData('moveToAll')">
                <input class="btn btn_next" type="submit" :value="$gettext('Přepsat prázdné')" @click.prevent="moveExternalData('moveToEmpty')">
            </p>
            <p class="field" v-for="externalDataKey in Object.keys(externalShowData)" :key="externalDataKey">
              <label :for="externalDataKey">
                {{externalShowData[externalDataKey].title}}
              </label>
              <input
                v-if="externalShowData[externalDataKey].type !== 'textarea'"
                :id="externalDataKey"
                :name="externalDataKey"
                size="30"
                :value="externalShowData[externalDataKey].value"
                :type="externalShowData[externalDataKey].type ? externalShowData[externalDataKey].type : 'text'"
                disabled=""
              />
              <textarea
                v-if="externalShowData[externalDataKey].type === 'textarea'"
                :id="externalDataKey"
                :name="externalDataKey"
                rows="6"
                cols="50"
                disabled=""
                v-model="externalShowData[externalDataKey].value"
              />
            </p>
          </form>
        </div>
        <div :title="translations.pictures">
          <div class="image_db_list scroll">
            <div class="image_db" v-for="(poster, index) in itemImages">
              <div class="image_db_inner" :ref="'imageDbInner' + index">
                <img :src="poster.src" alt="obrazek"/>
                <p class="image_db_overlay">
                  <input
                      type="checkbox"
                      :id="'imageDb' + index"
                      :name="'imageDb' + index"
                      @click="setAsMove(poster, index)"
                      :ref="'imageDbCheckbox' + index"
                  />
                  <label :for="'imageDb' + index" class="to_gallery" :title="translations.moveToGallery"></label>
                  <a
                      @click="setAsPortrait(poster, index)"
                      v-if="imagesLoaded === maxImages && isPortrait(poster.src)"
                      class="image_db_switch portrait_switch"
                      :title="translations.setAsPortrait"
                      :ref="'imageDbPortrait' + index"
                  />
                  <a
                      @click="setAsLandscape(poster, index)"
                      v-if="imagesLoaded === maxImages && isLandscape(poster.src)"
                      class="image_db_switch landscape_switch"
                      :title="translations.setAsLandscape"
                      :ref="'imageDbLandscape' + index"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </app-tabs>
  </sidebar-item>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { AUTOCOMPLETE_TITLE } from 'symbols/autocomplete'
import SidebarItem from '../Common/Sidebar/SidebarItem'
import ItemMoveEverything from './ItemMoveEverything'
import ItemCheckboxInput from './ItemCheckboxInput'
import SidebarDropdown from '../Common/Sidebar/SidebarDropdown'

export default {
  name: 'item-external-source',
  components: {
    SidebarDropdown,
    ItemCheckboxInput,
    ItemMoveEverything,
    SidebarItem
  },
  props: {
    languageId: {
      type: Number
    },
    showImages: {
      type: Array,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    dataPending: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemId: null,
      itemType: null,
      imagesLoaded: 0,
      maxImages: 0,
      extended: false,
      pending: false,
      externalDbAutocompleteHeaders: [
        { name: 'ČSFD', type: 'csfd' },
        { name: 'TMDB', type: 'tmdb' }
      ],
      externalCsfdShows: [],
      externalTmdbShows: [],
      itemJustSelected: false,
      itemImages: [],
      itemContentLabelIds: [],
      itemFormatLabelId: null,
      itemCountryIds: [],
      itemDurationInMinutes: null,
      itemPeriodic: null,
      externalShowData: {
        link: {
          title: 'Link',
          value: '',
          type: 'url'
        },
        name: {
          title: 'Název',
          value: ''
        },
        originalName: {
          title: 'Originální název',
          value: ''
        },
        genre: {
          title: 'Žánr',
          value: ''
        },
        country: {
          title: 'Země',
          value: ''
        },
        year: {
          title: 'Rok',
          value: ''
        },
        duration: {
          title: 'Stopáž',
          value: ''
        },
        rating: {
          title: 'Hodnocení',
          value: '',
          type: 'number'
        },
        directors: {
          title: 'Režie',
          value: ''
        },
        cast: {
          title: 'Hrají',
          value: '',
          type: 'textarea'
        },
        description: {
          title: 'Popis',
          value: '',
          type: 'textarea'
        }
      }
    }
  },
  computed: {
    translations() {
      return {
        searchByName: this.$gettext('Hledat podle názvu'),
        texts: this.$gettext('Texty'),
        pictures: this.$gettext('Obrázky'),
        moveToGallery: this.$gettext('Přesunout do galerie'),
        setAsPortrait: this.$gettext('Nastavit jako portrait'),
        setAsLandscape: this.$gettext('Nastavit jako landscape')
      }
    },
    autocompleteSource() {
      return this.externalTmdbShows.map(item => ({
        _id: item.id,
        type: 'tmdb',
        periodic: item.periodic,
        [AUTOCOMPLETE_TITLE]: `${item.name}`
      })).concat(this.externalCsfdShows.map(item => ({
        _id: item.id,
        type: 'csfd',
        [AUTOCOMPLETE_TITLE]: `${item.name}`
      })))
    },
    currentItem() {
      return this.externalTmdbShows.find(v => v.id === this.itemId)
    }
  },
  methods: {
    ...mapActions(['getExternalDbShows', 'getExternalDbShow']),
    async onItemClicked(id, item) {
      this.itemReset()
      if (id) {
        await this.itemSelected(id, item)
        this.$refs.autocompleteSearch.blur()
      }
    },
    async itemSelected(id, item) {
      this.itemId = id
      this.itemType = item.type
      this.itemPeriodic = item.periodic
      this.itemJustSelected = true
      this.imagesLoaded = 0

      const response = await this.getExternalDbShow({
        params: {
          id: id,
          type: item.type,
          periodic: item.periodic ? 1 : 0,
          lang: this.languageId
        }
      })

      if (response && response.data && response.data.data) {
        const detailData = response.data.data

        if (detailData.actors) { this.externalShowData.cast.value = detailData.actors }
        if (detailData.content_label_ids) { this.itemContentLabelIds = detailData.content_label_ids }
        if (detailData.country_formatted) { this.externalShowData.country.value = detailData.country_formatted }
        if (detailData.country_ids) { this.itemCountryIds = detailData.country_ids }
        if (detailData.description) { this.externalShowData.description.value = detailData.description }
        if (detailData.detailUrl) { this.externalShowData.link.value = detailData.detailUrl }
        if (detailData.year) { this.externalShowData.year.value = detailData.year }
        if (detailData.director) { this.externalShowData.directors.value = detailData.director }
        if (detailData.duration_minutes) {
          this.itemDurationInMinutes = detailData.duration_minutes
          if (detailData.duration_formatted) {
            this.externalShowData.duration.value = detailData.duration_formatted
          } else {
            this.externalShowData.duration.value = detailData.duration_minutes + ' min'
          }
        }
        if (detailData.format_label_id) { this.itemFormatLabelId = detailData.format_label_id }
        if (detailData.genre) { this.externalShowData.genre.value = detailData.genre }
        if (detailData.name) { this.externalShowData.name.value = detailData.name }
        if (detailData.original_name) { this.externalShowData.originalName.value = detailData.original_name }
        if (detailData.periodic) { this.itemPeriodic = detailData.periodic }
        if (detailData.rating) { this.externalShowData.rating.value = detailData.rating }
        if (detailData.posters) { this.itemImages = detailData.posters }
        if (detailData.backdrops) { this.itemImages = this.itemImages.concat(detailData.backdrops) }
        if (this.showImages) {
          this.itemImages = this.itemImages.filter(image => {
            return !this.showImages.includes(image)
          })
        }
      }

      this.maxImages = this.itemImages.length
      for (let i = 0; i < this.itemImages.length; i++) {
        const img = new Image()
        img.src = this.itemImages[i]
        img.onload = () => {
          this.imagesLoaded++
        }
        this.itemImages[i] = {
          'src': this.itemImages[i],
          'toMove': false,
          'portrait': false,
          'landscape': false
        }
      }
    },
    isPortrait(src) {
      const img = new Image()
      img.src = src
      return img.width <= img.height
    },
    isLandscape(src) {
      const img = new Image()
      img.src = src
      return img.width >= img.height
    },
    setAsPortrait(img, index) {
      this.itemImages.forEach((image, i) => {
        if (image.portrait) {
          image.portrait = false
          this.checkItem('imageDbPortrait', i)
        }
      })
      img.portrait = !img.portrait
      this.checkItem('imageDbPortrait', index)
      if (img.portrait && !img.toMove) {
        img.toMove = true
        this.checkItem('imageDbInner', index)
        this.$refs['imageDbCheckbox' + index][0].checked = true
      }
      this.$emit('imagesChanged', this.itemImages.filter(image => image.toMove === true))
    },
    setAsLandscape(img, index) {
      this.itemImages.forEach((image, i) => {
        if (image.landscape) {
          image.landscape = false
          this.checkItem('imageDbLandscape', i)
        }
      })
      img.landscape = !img.landscape
      this.checkItem('imageDbLandscape', index)
      if (img.landscape && !img.toMove) {
        img.toMove = true
        this.checkItem('imageDbInner', index)
        this.$refs['imageDbCheckbox' + index][0].checked = true
      }
      this.$emit('imagesChanged', this.itemImages.filter(image => image.toMove === true))
    },
    setAsMove(img, index) {
      img.toMove = !img.toMove
      if (!img.toMove) {
        img.portrait = false
        img.landscape = false
      }
      this.checkItem('imageDbInner', index)
      this.$refs['imageDbCheckbox' + index][0].checked = !this.$refs['imageDbCheckbox' + index][0].checked
      if (this.$refs['imageDbPortrait' + index]) {
        this.$refs['imageDbPortrait' + index][0].classList.remove('checked')
      }
      if (this.$refs['imageDbLandscape' + index]) {
        this.$refs['imageDbLandscape' + index][0].classList.remove('checked')
      }
      this.$refs['imageDbCheckbox' + index][0].checked = !this.$refs['imageDbCheckbox' + index][0].checked
      this.$emit('imagesChanged', this.itemImages.filter(image => image.toMove === true))
    },
    checkItem(stringClass, index) {
      if (this.$refs[stringClass + index][0].classList.contains('checked')) {
        this.$refs[stringClass + index][0].classList.remove('checked')
      } else {
        this.$refs[stringClass + index][0].classList.add('checked')
      }
    },
    itemReset() {
      this.itemId = null
      this.itemType = null
      this.itemJustSelected = false
      this.itemBackdrops = []
      this.itemPosters = []
      this.itemContentLabelIds = []
      this.itemFormatLabelId = null
      this.itemCountryIds = []
      this.itemDurationInMinutes = null
      this.itemPeriodic = null

      Object.keys(this.externalShowData).forEach(v => {
        this.externalShowData[v].value = ''
      })
    },
    moveExternalData(eventName) {
      var data = {}

      Object.keys(this.externalShowData).forEach(v => {
        data[v] = this.externalShowData[v]
      })

      this.$emit(eventName, {
        externalShowData: data,
        id: this.itemId,
        type: this.itemType,
        contentLabelIds: this.itemContentLabelIds,
        formatLabelId: this.itemFormatLabelId,
        countryIds: this.itemCountryIds,
        durationInMinutes: this.itemDurationInMinutes,
        periodic: this.itemPeriodic
      })
    },
    onFocus() {
      this.extended = true
    },
    onBlur() {
      this.extended = false
    },
    async onInputChanged(value) {
      if (!this.itemJustSelected) {
        this.itemId = null
        this.externalCsfdShows = []
        this.externalTmdbShows = []

        if (value.length >= 1) {
          this.pending = true
          const response = await this.getExternalDbShows({
            params: {
              q: value,
              lang: this.languageId
            }
          })
          this.pending = false

          if (response.data) {
            if (response.data.csfd) {
              this.externalCsfdShows = response.data.csfd
            }
            if (response.data.tmdb) {
              this.externalTmdbShows = response.data.tmdb
            }
          }
        }
      } else {
        this.itemJustSelected = false
      }
    }
  }
}
</script>
